// extracted by mini-css-extract-plugin
module.exports = {"row":"Table_row__2mp6P","th":"Table_th__3GnPl","btnWrapper":"Table_btnWrapper__3DNe_","btn":"Table_btn__iqN6y","pageLimit":"Table_pageLimit__1e7lV"};